import type { RuleHandler } from "../types";
import { setIncludes } from "../setIncludes";

const checkAllMarketIdsMustMatch: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  if (
    !setIncludes(
      new Set(requirementAttributes?.marketIds),
      new Set(context.selection.marketIds),
      requirementAttributes.allMarketIdsMustMatch || false,
    )
  ) {
    return false;
  }

  return true;
};

export { checkAllMarketIdsMustMatch };
